/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';
import { WorkLogStatus } from '../../models/work-log-status';

export interface WorkLogsControllerFindMy$Params {
  page?: number;
  limit?: number;

/**
 * Search by volunteer name or work type name
 */
  search?: string;
  status?: WorkLogStatus;
  userId?: string;
  workTypeId?: string;
  sortBy?: 'createdAt' | 'updatedAt' | 'workDate' | 'hoursWorked' | 'earnedPoints' | 'workTypeName' | 'volunteerName';
  sortOrder?: 'ASC' | 'DESC';
}

export function workLogsControllerFindMy(http: HttpClient, rootUrl: string, params?: WorkLogsControllerFindMy$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerFindMy.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('status', params.status, {});
    rb.query('userId', params.userId, {});
    rb.query('workTypeId', params.workTypeId, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

workLogsControllerFindMy.PATH = '/work-logs/my';
